import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import ArrowButton from "components/button/ArrowButton";

import SidebarFloatMenu from "../SidebarFloatMenu";
import SidebarHeadingTitle from "../SidebarHeadingTitle";
import InventoryName from "./components/InventoryName";
import BottomDrawer from "../BottomDrawer";
import InventoryMenuContent from "./components/InventoryMenuContent";

import {SidebarContext} from "../../../../SidebarContext";

function Inventory(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const {currentInventory, isMobile} = useContext(SidebarContext);

    function handleClick(event){
        setAnchorEl(event.currentTarget);
    }

    if (!currentInventory) {
        return null;
    }

    return (
        <div style={{
            paddingLeft: '12px',
            paddingRight: '12px'
        }}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.inventory.title' />
            </SidebarHeadingTitle>
            <ArrowButton open={!!anchorEl} onClick={handleClick}>
                <InventoryName name={currentInventory.name} />
            </ArrowButton>
            {isMobile ? (
                <BottomDrawer
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    title={<FormattedMessage id='sidebar.inventory.menu.title' />}
                >
                    <InventoryMenuContent />
                </BottomDrawer>
            ) : (
                <SidebarFloatMenu
                    open={!!anchorEl}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                >
                    <InventoryMenuContent />
                </SidebarFloatMenu>
            )}
        </div>
    );
}

export default Inventory;
